import React from "react";
import styled from "styled-components";
import { screenSizes } from "../../styles/theme";
import { useNavigate } from "react-router-dom";

const HeroSectionContainer = styled.div`
  height: 366px;
  margin-top: 50px;
  padding: 2rem 6rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: ${screenSizes.L}px) {
    padding: 1rem;
    margin-top: 100px;
    }
  }
`;

const TitleContainer = styled.div`
  color: #091c00;

  .ai {
    font-size: 96px;
    font-weight: 400;
    @media (max-width: ${screenSizes.L}px) {
    font-size: 64px;
    }
  }

  .ranking {
    background-color: rgba(9, 28, 0, 0.2);
    font-size: 96px;
    font-weight: 700;
    @media (max-width: ${screenSizes.L}px) {
    font-size: 64px;
    }
  }

  .description {
    color: rgba(9, 28, 0, 0.7);
    font-size: 18px;
    font-weight: 400;
    margin-top: 16px;
  }
`;

const ActionButtonContainer = styled.div`
  position: relative;
`;

const ActionButton = styled.div`
  position: relative;
  font-family: "Manrope", sans-serif;
  background-color: #ff9d59;
  height: 160px;
  width: 160px;
  border-radius: 50%;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  cursor: pointer;
  z-index: 9;
  &:hover {
    background-color: #E0772D;
  }
`;

const HeroSection = () => {
  const isMobile = window.innerWidth <= 1024;
  const navigate = useNavigate();

  return (
    <HeroSectionContainer>
      <TitleContainer>
        <span className="ai">Starting work</span>
        <br />
        <span className="ranking">Together</span>
        <p className="description">
          Join the world's largest Digital Assets marketplace and start<br/> your digital art
          collection journey today.
        </p>
      </TitleContainer>
      {!isMobile && <ActionButtonContainer>
        <ActionButton onClick={() => navigate("/marketplace")}>Start Discovery</ActionButton>
      </ActionButtonContainer>}
    </HeroSectionContainer>
  );
};

export default HeroSection;
